var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportsHb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "5 6 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8308_3497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 11.4986L17.2266 10.0494L19.9609 10.4596C20.5625 11.4986 20.918 12.6471 20.9727 13.8228L19.0039 15.5455L17.3359 14.8619L16.2422 11.4986ZM14.3008 17.4869L17.1445 15.4361L18.7578 16.1197L19.0039 19.0182C18.3477 19.6744 17.6367 20.1939 16.8164 20.5494L14.3008 19.3189V17.4869ZM11.2383 9.69394L12.5234 7.28769C13.4805 7.09628 14.4922 7.09628 15.4492 7.28769L16.7344 9.69394L15.7227 11.1432H12.25L11.2383 9.69394ZM19.3594 16.0377L20.9727 14.6432C20.8633 16.0103 20.3984 17.2955 19.5508 18.3619L19.3594 16.0377ZM8.50391 9.77597C9.35156 8.73691 10.4453 7.94394 11.7031 7.50644L10.6914 9.44785L8.50391 9.77597ZM7 13.8228C7.05469 12.6471 7.41016 11.4713 8.01172 10.4596L10.7461 10.0494L11.7305 11.4986L10.6367 14.8346L8.96875 15.5455L7 13.8228ZM8.96875 19.0182L9.21484 16.1197L10.8281 15.4361L13.6719 17.4869V19.3189L11.1562 20.5494C10.3359 20.1666 9.59766 19.6744 8.96875 19.0182ZM7 14.6432L8.61328 16.0377L8.42188 18.3619C7.60156 17.2955 7.10938 16.0103 7 14.6432ZM11.9492 20.8228L13.9727 19.8385V19.8658L14 19.8385L16.0234 20.8228C15.3672 21.0416 14.6836 21.1236 14 21.1236C13.2891 21.1236 12.6055 21.0416 11.9492 20.8228ZM11.2383 14.9713L12.3047 11.7447H15.668L16.7344 14.9713L14 16.9674L11.2383 14.9713ZM19.4688 9.77597C18.6211 8.73691 17.5273 7.94394 16.2695 7.50644L17.2812 9.44785L19.4688 9.77597Z",
    fill: "#ADF106"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8308_3497",
    x: -2,
    y: -1.90372,
    width: 31.9727,
    height: 32.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.945098 0 0 0 0 0.0235294 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8308_3497"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8308_3497",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsHb);
export default ForwardRef;